export class EvaluacionPendienteVisualizacion {
    tipovisualizacionpreguntaid: number = 0;
    tipovisualizacioncompetenciacriterioid: number = 0;
    tipovisualizacionrespuestaid: number = 0;
    
    constructor(init?: Partial<EvaluacionPendienteVisualizacion>) {
        Object.assign(this, init);
    }
    
    }